module.exports = __webpack_public_path__ + "static/media/container-005.2ce8f1e1.jpg";